module.exports = __webpack_public_path__ + "img/Pannernservice DACH-DE-CHD.2cc4b2c3.png";